import Action from "./Action";
import Shape from "../Main/Shape.js";
import {Serialization} from "../Main/Serializer";

export default class ShapeChangeFillInteriorAction implements Action {

    private readonly oldFillInterior: boolean;

    constructor(private shape: Shape, private newFillInterior: boolean) {
        this.oldFillInterior = this.shape.getFillInterior();
    }

    public apply() {
        this.shape.setFillInterior(this.newFillInterior);
    }

    public revert() {
        this.shape.setFillInterior(this.oldFillInterior);
    }

    public merge(newAction: Action): boolean {
        return false;
    }

    public serializeForDebug(): Serialization {
        return {
            shape: this.shape.id,
            oldFillInterior: this.oldFillInterior,
            newFillInterior: this.newFillInterior,
        };
    }
}
